import { Component, inject } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { CommonModule } from '@angular/common';
import { AuthService } from 'auth';
import { FullStoryService } from 'fullstory';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'lib-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  imports: [ButtonModule, CommonModule, MatSnackBarModule, ToastModule],
  providers: [MessageService],
})
export class ProfileComponent {
  private messageService = inject(MessageService);
  private fullStoryService = inject(FullStoryService);
  private authService = inject(AuthService);

  public user$ = this.authService.actualUserOktaData$;
  public resetLoading = false;

  reset(): void {
    this.resetLoading = true;
    this.authService
      .resetActualUserPassword()
      .pipe(finalize(() => (this.resetLoading = false)))
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            detail: `Your password reset instructions have been sent to your e-mail.`,
            sticky: true,
          });
        },
        error: (error) => {
          this.resetLoading = false;
          this.fullStoryService.sendEvent('Home-Dot: Reset Password - Error', {
            error_info: error,
          });
          this.messageService.add({
            severity: 'error',
            detail: error.errorSummary,
            sticky: true,
          });
        },
      });
  }
}
